import { render, staticRenderFns } from "./loginMain.vue?vue&type=template&id=656df322&scoped=true&"
import script from "./loginMain.vue?vue&type=script&lang=js&"
export * from "./loginMain.vue?vue&type=script&lang=js&"
import style0 from "./loginMain.vue?vue&type=style&index=0&id=656df322&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656df322",
  null
  
)

export default component.exports